<div class="rd-widget table-widget">
  <table class="widgetLeaseComparablesSummaryClass widget-large cellspacing-0 cellpadding-0" *ngIf="widgetData" aria-hidden="true">
    <thead>
      <dynamic-growth-row [row]="1" [widget]="this">
        <tr class="widget-ruller-flex">
          <th scope="col" colspan="21" class="widget-grid-column cap-rate-comps-widget-red" style="text-align: start;">
            <widget-value class="cap-rate-comps-widget-red" [align]="'left'" [color]="'white'" [bold]="true">Cap Rate Comps</widget-value>
          </th>
        </tr>
      </dynamic-growth-row>
      <dynamic-growth-row [row]="2" [widget]="this">
        <tr class="dark-grey-line header-titles">
          <th scope="col" colspan="2">
            <div>{{'capRateComps.no' | rdTranslate}}</div>
          </th>
          <th scope="col" colspan="2">
            <div>{{'capRateComps.name' | rdTranslate}}</div>
          </th>
          <th scope="col" colspan="2">
            <div>{{'capRateComps.city' | rdTranslate}}</div>
          </th>
          <th scope="col" colspan="2">
            <div>{{'capRateComps.state' | rdTranslate}}</div>
          </th>
          <th scope="col" colspan="2">
            <div>{{'capRateComps.rentableArea' | rdTranslate}}</div>
          </th>
          <th scope="col" colspan="2">
            <div>{{'capRateComps.yearBuilt' | rdTranslate}}</div>
          </th>
          <th scope="col" colspan="2">
            <div>{{'capRateComps.price' | rdTranslate}}</div>
          </th>
          <th scope="col" colspan="2">
            <div>{{'capRateComps.pricePerRA' | rdTranslate}}</div>
          </th>
          <th scope="col" colspan="2">
            <div>{{'capRateComps.date' | rdTranslate}}</div>
          </th>
          <th scope="col" colspan="2">
            <div>{{'capRateComps.occupancy' | rdTranslate}}</div>
          </th>
          <th scope="col" colspan="1">
            <div>{{'capRateComps.capRate' | rdTranslate}}</div>
          </th>
        </tr>
      </dynamic-growth-row>
    </thead>
    <tbody class="extraTbody">
      <ng-container *ngFor="let entry of widgetData.rows; let i = index">
        <ng-container *ngIf="entry.name === 'Supplemental Sales'">
          <dynamic-growth-row [row]="i + 3" [widget]="this">
            <tr [ngClass]="{'light-grey-line': (i % 2 === 0)}">
              <td colspan="2">&nbsp;</td>

              <td colspan="19">
                <widget-value [align]="'left'">{{entry.name}}</widget-value>
              </td>
            </tr>
          </dynamic-growth-row>
        </ng-container>
        <ng-container *ngIf="entry.name !== 'Supplemental Sales'">
          <dynamic-growth-row [row]="i + 4" [widget]="this">
            <tr [ngClass]="{'light-grey-line': (i % 2 === 0)}">
              <td colspan="2">
                <widget-value [align]="'left'">{{entry.no}}</widget-value>
              </td>
              <td colspan="2">
                <widget-value [align]="'left'">{{entry.name}}</widget-value>
              </td>
              <td colspan="2">
                <widget-value [align]="'left'">{{entry.city}}</widget-value>
              </td>
              <td colspan="2">
                <widget-value [align]="'left'">{{entry.state}}</widget-value>
              </td>
              <td colspan="2">
                <widget-value [align]="'left'">{{entry.rentableArea | rdLocalizedNumber:0}}</widget-value>
              </td>
              <td colspan="2">
                <widget-value [align]="'left'">{{entry.yearBuilt}}</widget-value>
              </td>
              <td colspan="2">
                <widget-value [align]="'left'">{{currency}} {{entry.price | rdLocalizedNumber:0}}</widget-value>
              </td>
              <td colspan="2">
                <widget-value [align]="'left'">{{currency}} {{entry.pricePerRA | rdLocalizedNumber:0}}</widget-value>
              </td>
              <td colspan="2">
                <widget-value [align]="'left'">{{entry.date | rdLocalizedDate}}</widget-value>
              </td>
              <td colspan="2">
                <widget-value [align]="'left'">{{(entry.occupancy * 100) | rdLocalizedNumber:2}}%</widget-value>
              </td>
              <td colspan="1">
                <widget-value [align]="'left'">{{(entry.capRate * 100) | rdLocalizedNumber:2}}%</widget-value>
              </td>
            </tr>
          </dynamic-growth-row>
        </ng-container>
      </ng-container>
      <dynamic-growth-row [row]="widgetData.rows?.length + 5" [widget]="this">
        <tr class="footer-information">
          <td colspan="20">
            <div class="footer-label">{{'capRateComps.averageMean' | rdTranslate}}</div>
          </td>
          <td colspan="1">
            <widget-value [align]="'right'" [color]="'white'">{{(widgetData.averageMean * 100) | rdLocalizedNumber:2}}%</widget-value>
          </td>
        </tr>
      </dynamic-growth-row>
      <dynamic-growth-row [row]="widgetData.rows?.length + 6" [widget]="this">
        <tr class="footer-information">
          <td colspan="20">
            <div class="footer-label">{{'capRateComps.median' | rdTranslate}}</div>
          </td>
          <td colspan="1">
            <widget-value [align]="'right'" [color]="'white'">{{(widgetData.median * 100) | rdLocalizedNumber:2 }}%</widget-value>
          </td>
        </tr>
      </dynamic-growth-row>
    </tbody>
  </table>
</div>
